var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3344 5.8645C11.0557 5.8645 10.8296 6.09066 10.8296 6.36932V12.6796C10.8296 12.9582 11.0557 13.1844 11.3344 13.1844C11.6131 13.1844 11.8392 12.9582 11.8392 12.6796V6.36932C11.8392 6.09066 11.6131 5.8645 11.3344 5.8645Z",
    fill: "#F7931E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3344 14.4465C11.0557 14.4465 10.8296 14.6727 10.8296 14.9514V15.961C10.8296 16.2397 11.0557 16.4658 11.3344 16.4658C11.6131 16.4658 11.8392 16.2397 11.8392 15.961V14.9514C11.8392 14.6727 11.6131 14.4465 11.3344 14.4465Z",
    fill: "#F7931E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7012 0.789035C12.4157 0.294816 11.9048 -1.54059e-08 11.3344 -1.54059e-08C10.7639 -1.54059e-08 10.253 0.294816 9.96756 0.789035L0.213918 17.6826C-0.071306 18.1768 -0.071306 18.7417 0.213918 19.2357C0.499142 19.7299 1.01027 20 1.58072 20H21.088C21.6585 20 22.1696 19.7299 22.4548 19.236C22.74 18.7417 22.74 18.1645 22.4548 17.6702L12.7012 0.789035ZM21.5805 18.7311C21.531 18.8164 21.3841 18.9904 21.088 18.9904H1.58072C1.28464 18.9904 1.13774 18.8164 1.08827 18.7311C1.0388 18.6458 0.940103 18.4318 1.08827 18.1751L10.8422 1.28755C10.9901 1.03084 11.2359 1.00636 11.3344 1.00636C11.4328 1.00636 11.6787 1.03564 11.8268 1.29209L21.5805 18.1741C21.7286 18.4308 21.6297 18.6456 21.5805 18.7311Z",
    fill: "#F7931E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f854a4b86d6fb7805d5c83c30ad90c9b.svg";
export { ForwardRef as ReactComponent };